<template>
  <div class="card border-0 bg-default">
    <div class="card-body">
      <div class="d-flex flex-wrap align-items-center">
        <i class="fe fe-user-plus font-size-50 mr-3" :style="setColor(countUserBankTotal).color" />
        <div>
          <div class="font-size-30 font-weight-bold" :style="setColor(countUserBankTotal).color">{{ setComma(countUserBankTotal) }} รายการ</div>
          <div class="font-size-18 font-weight-bold" :style="setColor(countUserBankTotal).color">จำนวนสมาชิกใหม่</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'KitChart11',
  props: [
    'chartDataCountUserBank',
    'countUserBankTotal',
  ],
  methods: {
    setColor(countUserBankTotal) {
      const nameColorUp = [{ color: 'color: #368db7' }]
      return countUserBankTotal !== '' ? nameColorUp[0] : ''
    },
    setComma(value) {
      if (value > 0 && value !== null) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return 0
      }
    },
  },
}
</script>
<style lang="scss" module>
// @import "./style.module.scss";
</style>
